<template>
  <div>
    <div v-if="!readOnly" class="op">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>

    <div v-if="!readOnly" class="cr">
      <label>{{ $t('corrente-de-entrada-de-temperatura') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="current"
        @change="changeCurrent()"
        :options="currents"
      ></b-form-select>
    </div>

    <b-form class="b-layout" @submit.prevent="">
      <div v-if="operationSelected && current" class="varieables">
        <b-card class="card">
          <div class="inp">
            <label>{{ $t('umidade-do-bagaco') }} </label>
            <input
              class="ml-5"
              max="100"
              v-model="umidadeC6.value"
              type="number"
            />
          </div>

          <div class="inp">
            <label>{{ $t('embebicao-fibra') }} </label>
            <input class="ml-5" max="100" v-model="tx_agua.value" type="number" />
          </div>

          <div class="inp">
            <label>{{ $t('temp-da-embebicao-c') }} </label>
            <input
              class="ml-5"
              min="0"
              v-model.number="tempEm"
              type="number"
            />
          </div>

          <div class="inp">
            <label>{{ $t('temp-do-caldo-misto-c') }} </label>
            <input
              class="ml-5"
              min="0"
              v-model="TCaldo.value"
              type="number"
            />
          </div>
        </b-card>

        <b-card class="card">
          <div class="inp">
            <label>{{ $t('ocupacao-1') }} </label>
            <p>{{ this.Ocupacao.value | ParseNumber  }}</p>
          </div>

          <div class="inp">
            <label>{{ $t('eficiencia-da-extracao') }} </label>
            <p>{{ this.eficienciaExtracao.value | ParseNumber }}</p>
          </div>
        </b-card>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber, NumberFormat } from "../../utils/tools";
import { FiltersMixin }  from '../../../mixins/filtersMixin'

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
     readOnly:{
      type: Boolean,
      default: false,
    }
  },

  mixins: [ FiltersMixin ],


  data() {
    return {
      umidadeC6: {},
      tx_agua: {},
      TCaldo: {},
      Ocupacao: {},
      eficienciaExtracao: {},
      propTemp: {},
      tempEm: 0,
      operations: [{ value: null, text:this.$t('selecione-um-difusor')  }],
      operationSelected: null,
      currents: [{ value: null, text:this.$t('selecione-um-difusor') }],
      current: null,
      operationAttributeList: [],
      attributesList:this.$t('selecione-um-difusor'),
      firstLoad: false,
      attrList: [
        "umidadeC6",
        "tx_agua",
        "TCaldo",
        "Ocupacao",
        "eficienciaExtracao",
      ],
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      let parse = (value) => value.replace(".", "").replace(",", ".");

      this.attrList.forEach((attr) => {
        let prop = this.operationAttributeList.find((p) => attr == p.caption);
      
        if(prop) {
          this[attr] = prop
          if (this[attr]) this[attr].value = parse(this[attr].value);
        }
      });
      this.updateNode();
    },
    
    current(value) {
      if (value) this.node.currentTempEm = value;
    },

    tempEm(value) {
      this.propTemp.value = NumberFormat(value)
      this.updateNode();
    },

    "umidadeC6.value"() {
      this.updateNode();
    },

    "tx_agua.value"() {
      this.updateNode();
    },

    "TCaldo.value"() {
      this.updateNode();
    },
  },
  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;

        if (this.node.currentTempEm) {
          this.current = this.node.currentTempEm;
          this.changeCurrent();
        }

        this.firstLoad = true;
        this.loadNotInput();
      }

      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }
        if (p.index == this.node.currentTempEm) { 
          this.propTemp = p
          this.tempEm = ParseToNumber(p.value)
        } 
      });
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    updateNode() {
      let attrs = [];

      if(this.umidadeC6.value)
        attrs.push(this.umidadeC6.clone())

      if(this.tx_agua.value)
        attrs.push(this.tx_agua.clone())

      if(this.TCaldo.value)
        attrs.push(this.TCaldo.clone())

      if(this.propTemp.value)
        attrs.push(this.propTemp.clone())

      this.node.attrs = attrs;
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Difusor/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
      },
  

    loadCurrent() {
      let crList = SingletonEnginnering.currents;
      this.currents.splice(1);
      crList.forEach((cr) => this.currents.push({ value: cr, text: cr }));
    },

    changeCurrent() {
      let attrs = SingletonEnginnering.getCurrentProperties(this.current);

      let props = SingletonEnginnering.getCurrentPropertiesAttributes(
        this.current,
        attrs[0]
      );
      props.forEach((p) => {
        if (p.key == "T") { 
          this.tempEm = ParseToNumber(p.value);
          this.propTemp = p;
        } 
      });
    },
  },

  mounted() {
    this.loadOperation();
    this.loadCurrent();
    this.loadNode();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

.card {
  margin: 10px;
}

input,
p {
  margin: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.op, .cr {
  margin: 2%;
}
</style>